module.exports = __webpack_public_path__ + "static/media/a1.08fd4a43.jpg";